import(/* webpackMode: "eager" */ "/vercel/path0/apps/finestra_pro/src/app/error.tsx");
